import { createSlice } from "@reduxjs/toolkit";
import { forgetExecutorSocketUrl, rememberExecutorSocketUrl } from "../../utils/session";

const initialState = {
	user: null,
	token: localStorage.getItem("token") || null,
	isAuthenticated: !!localStorage.getItem("token"),
	loading: false,
	error: null,
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		loginStart: (state) => {
			state.loading = true;
			state.error = null;
		},
		loginSuccess: (state, action) => {
			state.loading = false;
			state.isAuthenticated = true;
			state.user = action.payload.user;
			state.token = action.payload.token;
			state.error = null;
			localStorage.setItem("token", action.payload.token);
			rememberExecutorSocketUrl(action.payload.user);
		},
		loginFailure: (state, action) => {
			state.loading = false;
			state.isAuthenticated = false;
			state.user = null;
			state.token = null;
			state.error = action.payload;
			localStorage.removeItem("token");
		},
		logout: (state) => {
			state.user = null;
			state.token = null;
			state.isAuthenticated = false;
			state.error = null;
			localStorage.removeItem("token");
			forgetExecutorSocketUrl();
		},
		// The same login with a later expiry (utils/sessionKeeper)
		tokenRenewed: (state, action) => {
			state.token = action.payload;
			localStorage.setItem("token", action.payload);
		},
		updateUser: (state, action) => {
			state.user = { ...state.user, ...action.payload };
		},
		// The signed-in user as the backend has them now (role, visibility can
		// change while logged in; Layout reloads it)
		setCurrentUser: (state, action) => {
			state.user = action.payload;
			rememberExecutorSocketUrl(action.payload);
		},
	},
});

export const { loginStart, loginSuccess, loginFailure, logout, tokenRenewed, updateUser, setCurrentUser } =
	authSlice.actions;

export default authSlice.reducer;
